var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"grid__time-strip time-strip",class:{
    'time-strip--fixed': _vm.headerPosition === 'fixed',
    'time-strip--sticked': _vm.headerPosition === 'sticky',
  }},[_c('div',{staticClass:"time-strip__inner",style:({
      width: (_vm.width + "px"),
      transform: ("translate3d(" + (_vm.headerPosition === 'fixed' ? -_vm.gridTranslate : 0) + "px, 0px, 0px)"),
    })},[_vm._l((24 * _vm.daysNumber),function(hour){return _c('div',{key:hour,staticClass:"time-strip__column"},[_vm._v(" "+_vm._s(((_vm.formatHour(hour)) + ":00"))+" ")])}),_c('div',{staticClass:"grid__time-pointer time-pointer",style:({ width: (_vm.pointerPosition + "px") })})],2)])}
var staticRenderFns = []

export { render, staticRenderFns }